import { SousClient, useSociete, useTiersService } from '@europrocurement/l2d-domain';
import { filtersToElasticQuery } from '@europrocurement/l2d-redux-utils';

const useSocieteFilter = () => {
    const { sousClientsApi } = useTiersService();
    let searchClientTimeout: number | undefined;
    const xIdSociete = useSociete();

    const searchSociete = (term: string): Promise<Array<SousClient>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchClientTimeout);
            const fields: Array<string> = ['raisonSociale', 'siren', 'siret'];
            const clauses = { isSousclient: true };
            const search = [];

            if (term) {
                search.push({
                    bool: {
                        should: [
                            {
                                query_string: {
                                    query: `**${term}**`,
                                    fields,
                                },
                            },
                        ],
                    },
                });
            }

            const requestParameters = {
                xIdSociete,
                search: filtersToElasticQuery(clauses, search),
            };

            searchClientTimeout = setTimeout(() => {
                sousClientsApi
                    .getListTiersTiersCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<SousClient>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchSociete };
};

export default useSocieteFilter;
